module.exports = __webpack_public_path__ + "img/icon_mute_gray.3fe6a953.svg";